import { request } from './client';

export function getMetaDocument(orderId: number | string) {
  return request('GET', `/v1/account/order/${orderId}/meta/job_posting`, {});
}
export function retryGetMetaDocument(orderId: number | string) {
  return request('POST', `/v1/account/order/${orderId}/meta/job_posting/retry`, {}, {});
}
export function updateMetaDocument(orderId: number | string, blocks: any[]) {
  return request('PUT', `/v1/account/order/${orderId}/meta/job_posting`, {}, { data: blocks });
}
